<div class="docPage templatePage">
    <div class="alert alert-warning" role="alert" *ngIf="isNotFoundShow">
        {{ 'docPage.notFoundDoc' | translate }}
    </div>


    <cdk-virtual-scroll-viewport itemSize="90" class="list-viewport" *ngIf="isDocShow && currentDoc.type === DocumentType.MENU">
        <ul class="list-group">
            <li class="list-group-item cuseurClick" (click)="goPrevious()" *ngIf="havePrevious">
                <div class="media">
                    <div  class="ml-3 align-self-center">
                        <fa-icon icon="chevron-left" size="2x" [fixedWidth]="true"></fa-icon>
                    </div>
                    <div  class="mr-3 list-div-image">
                        <img moMediaSrcCache [mediaPath]="getThumbnailMediaPath(currentDoc)" class="list-image" >
                    </div>
                    <div class="media-body">
                        <h5 class="mt-0">{{ currentDoc.nom}}</h5>
                        <span [innerHTML]="currentDoc.nom"></span>
                    </div>
                </div>
            </li>


            <li class="list-group-item cuseurClick" *cdkVirtualFor="let doc of subDocs" (click)="chooseDoc(doc)">
                <div class="media">
                    <div  class="mr-3 list-div-image">
                        <img moMediaSrcCache [mediaPath]="getThumbnailMediaPath(doc)" class="list-image" >
                    </div>
                    <div class="media-body">
                        <h5 class="mt-0">{{ doc.nom}}</h5>
                        <span [innerHTML]="doc.subLabel"></span>
                    </div>
                    <div  class="ml-3 align-self-center">
                        <fa-icon icon="chevron-right" size="2x" [fixedWidth]="true"></fa-icon>
                    </div>
                </div>
            </li>
        </ul>
    </cdk-virtual-scroll-viewport>


    <div *ngIf="isDocShow && currentDoc.type === DocumentType.DOCUMENT && currentMedia != null" >
        <ul class="list-group" *ngIf="havePrevious">
            <li class="list-group-item cuseurClick" (click)="goPrevious()" >
                <div class="media">
                    <div  class="ml-3 align-self-center">
                        <fa-icon icon="chevron-left" size="2x" [fixedWidth]="true"></fa-icon>
                    </div>
                    <div  class="mr-3 list-div-image">
                        <img moMediaSrcCache [mediaPath]="getThumbnailMediaPath(currentDoc)" class="list-image" >
                    </div>
                    <div class="media-body">
                        <h5 class="mt-0">{{ currentDoc.nom}}</h5>
                        <span [innerHTML]="currentDoc.nom"></span>
                    </div>
                </div>
            </li>
        </ul>


        <pinch-zoom *ngIf="currentMedia.type === mediaType.IMAGE"
                    class="media-viewport">
            <img moMediaSrcCache [mediaPath]="getCurrentMediaPath()" />
        </pinch-zoom>

        <video *ngIf="currentMedia.type === mediaType.VIDEO"
               class="media-viewport"
               controls autoplay loop
               moVideoSrcCache [mediaPath]="getCurrentMediaPath()">
            <p><strong>Video Reader Error</strong></p>
        </video>


        <div moPdfSrcCache [mediaPath]="getCurrentMediaPath()" *ngIf="currentMedia.type === mediaType.PDF">

        </div>


    </div>
</div>

